<template>
  <section class="profile-area site-top-spacing">


    <!-- Profile Banner area Start -->
    <div class="profile-banner">
        <img v-if="userInfo && userInfo.coverphoto" :src="require(`@/assets/images/users/${userInfo.coverphoto}`)" alt="images" />
    </div>
    <!-- Profile Banner area End -->

    <!-- profile-wrap-start -->
    <div class="container">
        <div class="profile-wrap">

            <!-- profile-info-start -->
            <profile-info :userInfo="userInfo" :authUser="auth"></profile-info>
            <!-- /. profile-info-end -->

            <!-- profile-statistic-wrap-start -->
            <profile-statistic :profilestatistic="userInfo.profilestatistic"></profile-statistic>
            <!-- profile-statistic-wrap-end -->

            <!-- profile-activity-start -->
            <profile-activity></profile-activity>
            <!-- profile-activity-end -->
    
        </div>
    </div>
    <!-- profile-wrap-end -->


    <!-- modal area start-->
    <badges-modal></badges-modal>
    <!-- modal area end -->

    <!-- modal area start-->
    <profile-edit-modal :userData="userInfo"></profile-edit-modal>
    <!-- modal area end -->

    <!-- Followers Modal Start -->
    <followers-modal></followers-modal>
    <!-- Followers Modal End -->

    <!-- Followers Modal Start -->
    <following-modal></following-modal>
    <!-- Followers Modal End -->


    <!-- Login and signup button if not user logged in start -->
    <div class="auth-bottom-bar">
        <div class="auth-bottom-bar-left">
            <p>Unlock thousands of stories by signing up</p>
        </div>
        <div class="auth-bottom-bar-right">
            <a href="#">Signup</a>
            <a href="#">Login</a>
        </div>
    </div>
    <!-- Login and signup button if not user logged in end -->
  </section>
</template>


<script>
export default {
    data() {
        return {
            auth:false,
            userInfo: {}
        }
    }, 

    created() {

        /*
        *   Data get from firebase. And this is only for design purpose
        */
        this.$http.get('users.json').then(function(data){
            return data.json();
        }).then(function(data){
            for (var i = 0; i < data.length; i++) {
                if(data[i].username==this.$route.params.name) {
                    if(data[i].id==1) {
                        this.auth=true;
                    }
                    this.userInfo=data[i];
                } 
            }
        })



    }
}

</script>


<style>
    @import '../assets/css/profile.css';
</style>

